export default __webpack_public_path__ + "static/pic3-2b7b8cc54fe7df6f6a920d65ba35cdca.jpeg";